import { Injectable } from '@angular/core';
import { createStore, select, setProps, withProps } from '@ngneat/elf';
import { normalizeNullableDate } from '../helpers/date.helper';
import { BedomareViewModel } from '../models/bedomare-view-model.model';
import { Bedomare } from '../models/bedomare.model';
import { write } from './mutations';

const store = createStore(
  { name: 'bedomare' },
  withProps<{
    bedomare: Bedomare | undefined;
    bedomareData: BedomareViewModel | undefined;
  }>({
    bedomare: undefined,
    bedomareData: undefined,
  }),
);

@Injectable({ providedIn: 'root' })
export class BedomareRepository {
  bedomare$ = store.pipe(select((state) => state.bedomare));

  getBedomare() {
    return store.query((state) => state.bedomare);
  }

  getBedomareData() {
    return store.query((state) => state.bedomareData);
  }

  setBedomare(bedomare: Bedomare): Bedomare {
    const normalizedBedomare: Bedomare = {
      ...bedomare,
      forordnanden: (bedomare.forordnanden ?? []).map((forordnande) => ({
        ...forordnande,
        startDate: new Date(forordnande.startDate),
        endDate: new Date(forordnande.endDate),
        acceptDate: normalizeNullableDate(forordnande.acceptDate),
        sent: normalizeNullableDate(forordnande.sent),
      })),
      senastBekraftad: normalizeNullableDate(bedomare.senastBekraftad),
    };

    store.update(
      setProps(write((state) => (state.bedomare = normalizedBedomare))),
    );

    return normalizedBedomare;
  }

  setBedomareData(bedomareData: BedomareViewModel) {
    store.update(
      setProps(write((state) => (state.bedomareData = bedomareData))),
    );
  }
}
